module.exports = __webpack_public_path__ + "img/charts libraries.52779be7.png";